import { Component, OnInit, OnDestroy } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { HttpErrorResponse } from '@angular/common/http';
import { HealthService } from '../../services/health.service';
import { CustomerService } from '../../services/customer.service';
import { AccountService } from '../../services/account.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonfilterService } from '../../services/commonfilter.service';
import { FileUploadService } from '../../services/file-upload.service';
import { DisplayResultDialogComponent } from './display-result-dialog/display-result-dialog.component';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {

  sectors: any = [];
  branches: any = [];
  loginAnalytics = {
    accountInSession: '',
    todayLoggedInAccounts: '',
    curWeekLoggedInAccounts: '',
    curMonthLoggedInAccounts: ''
  };
  signupAnalytics = {
    todaySignupAcc: '',
    curWeekSignupAcc: '',
    curMonthSignupAcc: ''

  };
  consumerLoginAnalytics = {
    todayAndroidConsumerLoginCount: '',
    todayWebConsumerLoginCount: ' ',
    curWeekAndroidConsLoginCount: ' ',
    curWeekWebConsLoginCount: ' ',
    curMonthAndroidConsLoginCount: ' ',
    curMonthWebConsLoginCount: ' ',
    androidConsumerInSessionCount: ' ',
    webConsumerInSessionCount: ' ',
    todayIosConsumerLoginCount: ' ',
    curWeekIosConsLoginCount: ' ',
    curMonthIosConsLoginCount: ' ',
    iosConsumerInSessionCount: ' '

  };
  consumerSigninAnalytics = {
    todaySignedupWebConsumerCount: '',
    todaySignedupAndroidConsumerCount: '',
    todaySignedupIosConsumerCount: '',
    curWeekSignedupWebConsumerCount: '',
    curWeekSignedupAndroidConsumerCount: '',
    curWeekSignedupIosConsumerCount: '',
    curMonthSignedupWebConsumerCount: '',
    curMonthSignedupAndroidConsumerCount: '',
    curMonthSignedupIosConsumerCount: ''
  };
  transacyionsAnalytics = {
    todayCheckinsCount: '',
    todayAppointmentsCount: '',
    todayDonations: '',
    todayTokensAndCheckinsCount: '',
    todayTokensCount: '',
    todayTotalTransactions: '',
  };
  healthArray: any = [];
  healthy: any = [];
  healthCount = { 'periodic': '', 'nonperiodic': '' };
  licensepackages: any = [];
  dateTimeFilterArray: any = {};
  compliance = { 'all': '', 'day': '', 'month': '' };
  accountData: any = {};
  consumerData: any = {};
  healthData: any = {};
  serviceSector = 0;
  subDomains: any = [];
  fileToUpload: File = null;
  domain: any = 0;
  datePipe = new DatePipe('en-US');
  todayDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  subDomain: any = '';
  api_success: string;
  api_error1: string;
  api_error2: string;
  api_error5: string;
  api_error: string;
  uploadres: any = [];
  loading$: boolean;
  type: any;
  account;
  includeTest;
  accountConsumer;
  healthSubscription: Subscription;
  fileUploadZipService: Subscription;
  fileUploadSubscription: Subscription;
  outOfComplianceSubscription: Subscription;
  accountLicenseSubscription: Subscription;
  importedDate = false;
  cp_importedDate = false;
  branch_importedDate = false;
  branchService_importedDate = false;
  branchdepart_importedDate = false;
  subscriptions: Subscription[] = [];
  resultset: any;
  transactiondetails;
  criticalCount = 0;
  warningCount = 0;
  normalCount = 0;
  unknownCount = 0;
  transactionCount: any;
  dateRange;
  consumerdateRange;
  showDate: false;
  showDateConsumer: false;
  newlysignedfilterParam = '';
  consumer_filterparams = '';
  compliance_filterParams = '';
  license_filterParams = '';
  date;
  data: boolean;
  dateFrom: string;
  dateTo: string;
  kamdateFrom: any;
  kamdateTo: any;
  tableFilters: any = '';
  collapsed_active;
  collapsed_license;
  includeTest_License;
  show_count;
  showReal_count;
  email: any;
  api_success5: string;
  constructor(
    private service: DashboardService,
    private healthService: HealthService,
    private customerService: CustomerService,
    private accountService: AccountService,
    private commonService: CommonfilterService,
    private fileuploadService: FileUploadService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.healthArray = this.healthService.healthArray;
    this.dateTimeFilterArray = this.healthService.setFilterParam();
  }

  ngOnInit() {
    this.showDate = false;
    this.showDateConsumer = false;
    this.dateRange = false;
    this.account = false;
    this.includeTest = true;
    this.accountConsumer = false;
    this.consumerdateRange= false;
    this.includeTest_License= true;
    this.FetchConsumerAnalytics();
    
    if (this.sectors.length === 0) {
      this.FetchServiceSectors();
    }
    this.FetchAccountAnalytics(0);
    this.accountLicensePackages();
    // this.outofcompliance();
    this.getTransactionCount();
    this.getHealthComponentCountbyStatus();
  }

  getHealthComponentCountbyStatus() {
    this.subscriptions.push(this.healthService.getHealthComponents()
      .subscribe(data => {
        this.resultset = data;
        // console.log(this.resultset);
        this.getHealthStatus(this.resultset);
      }));
    // setInterval(() => {
    //   this.getHealthStatus(this.resultset);

    // }, 2000 * 60);
  }
  
  getHealthStatus(data) {


    this.subscriptions.push(
      this.healthService.getHealthStatus()
        .subscribe(result => {
          const componentArray = [];
          result.forEach(component => {
            component.cluster.forEach(cluster => {
              const clusterArray = [];
              if (typeof Object.keys(cluster) !== 'undefined' && Object.keys(cluster).length > 0) {
                Object.keys(cluster).forEach(ip => {
                  clusterArray.push({ 'ip': ip, 'status': cluster[ip].status });
                });
              }
              componentArray.push({ 'compId': component.compId, 'sourceId': component.sourceId, 'cluster': clusterArray });
            });
          });

          componentArray.forEach(comp => {
            const dataComponent = data.find(component =>
              component.sourceId === comp.sourceId && component.compId === comp.compId
            );
            dataComponent.clusterStatus = comp.cluster;
          });

          this.healthService.groupDatabySourceName(data);
          this.healthService.getHealthStatusCount(data);
        }));

  }
  FetchServiceSectors() {
    this.commonService.getServiceSectors().subscribe(
      (data) => {
        // console.log(JSON.stringify(data));
        this.sectors = data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log('An error occurred:', err.error.message);
        } else {
          console.log('Backend returned status code: ', err.status);
        }
      });
  }
  FetchAccountAnalytics(serviceSector) {
    console.log(this.account)
    if(this.account === true && this.dateRange === false){
      this.newlysignedfilterParam = '?isIncludeTest=' + this.account + '&isFilterByDate=' + this.dateRange  ;
    }
    else if(this.account === true && this.dateRange === true){
      this.newlysignedfilterParam = '?isIncludeTest=' + this.account + '&isFilterByDate=' + this.dateRange + '&dateFrom=' + this.dateFrom +'&dateTo=' +this.dateTo ;
    }
    else if(this.account === false && this.dateRange === true){
      this.newlysignedfilterParam = '?isIncludeTest=' + this.account + '&isFilterByDate=' + this.dateRange + '&dateFrom=' + this.dateFrom +'&dateTo=' +this.dateTo ;
    }
    else if(this.account === false && this.dateRange === false){
      this.newlysignedfilterParam = '?isIncludeTest=' + this.account + '&isFilterByDate=' + this.dateRange ;
    }
    this.accountService.getAccountAnalyticsBySector(serviceSector,this.newlysignedfilterParam).subscribe(
      (data) => {
        this.loginAnalytics = data.loginAnalytics;
        this.signupAnalytics = data.signupAnalytics;

      },
      (error) => {
        this.api_error1 = error.error;
      });
      setTimeout(() => {
        this.api_error1 = '';
      }, 3000);
  }
  settingDeafultValue(e) {
    console.log(this.dateRange);
    this.showDate= e.target.checked;
    if(!this.showDate){
      this.FetchAccountAnalytics(0);  
    }
    // if(this.showDate=== false){
    //   this.dateFrom = '';
    //   this.dateTo = '';
    // }
    // (e.target.checked) ? this.showDate = true : this.showDate = false;
}
settingDeafultValueconsumer(e) {
  this.showDateConsumer= e.target.checked;
  if(!this.showDateConsumer){
    this.FetchConsumerAnalytics();  
  }
}
  FetchConsumerAnalytics() {
    if(this.accountConsumer === true && this.consumerdateRange === false){
      this.consumer_filterparams = '?isIncludeTest=' + this.accountConsumer + '&isFilterByDate=' + this.consumerdateRange  ;
    }
    else if(this.accountConsumer === true && this.consumerdateRange === true){
      this.consumer_filterparams = '?isIncludeTest=' + this.accountConsumer + '&isFilterByDate=' + this.consumerdateRange + '&dateFrom=' + this.dateFrom +'&dateTo=' +this.dateTo ;
    }
    else if(this.accountConsumer === false && this.consumerdateRange === true){
      this.consumer_filterparams = '?isIncludeTest=' + this.accountConsumer + '&isFilterByDate=' + this.consumerdateRange + '&dateFrom=' + this.dateFrom +'&dateTo=' +this.dateTo ;
    }
    else if(this.accountConsumer === false && this.consumerdateRange === false){
      this.consumer_filterparams = '?isIncludeTest=' + this.accountConsumer + '&isFilterByDate=' + this.consumerdateRange ;
    }
    this.customerService.getConsumerAnalytics(this.consumer_filterparams).subscribe(
      (data) => {
        this.consumerLoginAnalytics = data.loginAnalytics;
        this.consumerSigninAnalytics = data.signupAnalytics;
      },
      (error) => {
        this.api_error2 = error.error;
      });
      setTimeout(() => {
        this.api_error2 = '';
      }, 3000);
      // (err: HttpErrorResponse) => {
      //   if (err.error instanceof Error) {
      //     console.log('An error occurred:', err.error.message);
      //   } else {
      //     console.log('Backend returned status code: ', err.status);
      //   }


      // });
  }
  onSectorChange(event): void {
    const newVal = event.target.value;
    this.FetchAccountAnalytics(newVal);
  }
  accountLicensePackages() {
    if(this.includeTest_License === true){
       this.show_count = true;
       this.showReal_count = false;
    }
    else{
      this.showReal_count = true;
      this.show_count = false;
    }
    this.license_filterParams = '?isIncludeTest=' + this.includeTest_License;
    this.accountLicenseSubscription = this.service.getAccountLicensePackages(this.license_filterParams)
      .subscribe(data => {
        this.licensepackages = JSON.parse(data);


      });
  }
  // outofcompliance() {
  //   this.compliance_filterParams = '?isIncludeTest=' + this.includeTest;
  //   this.outOfComplianceSubscription = this.service.getOutOfComplianceAccounts(this.compliance_filterParams).subscribe(
  //     data => {
  //       this.compliance.day = data[0];
  //       this.compliance.month = data[1];
  //       this.compliance.all = data[2];
  //     }
  //   );

  // }
  getTransactionCount() {
    this.service.getTransactions()
      .subscribe(res => {
        this.transactionCount = res;
        // console.log(this.transactionCount);
      });
  }
  getAccounts(sector, _agentType, category,_count) {
    this.tableFilters = this.commonService.filterParams_without_operators('bookingStat');
    const filterParam = 'serviceSector=' + sector + '&userAgentType=' + _agentType +'&category=' + category +'&isIncludeTest=' + this.account + '&isFilterByDate=' + this.dateRange+ '&'+ this.tableFilters;
    
    // this.accountService.getTotalFilterCount(filterParam).subscribe(data=>{
    //   this.accountData.count=data;
    // }
    // )
    //  this.accountService.getAccountsData(filterParam,'false',0,10).
    //  subscribe(res=>{
    // this.accountData.data=res;
    this.accountData.filterParam = filterParam;
    this.accountData.flag = true;
    this.accountData.count = _count;
    this.accountService.setDomainFilterValue(sector);
    this.accountService.setUserAgentFilterParam(_agentType);
    this.accountService.setCategoryFilterValue(category);
    this.accountService.storeAccountData(this.accountData);
    this.router.navigate(['../accounts/filter/list'], { relativeTo: this.route });

    // })

  }

  getAccountsByLicensePkg(license) {
    const licenseId = license.licPkgId;
    const filterParam = 'license-eq=' + licenseId + '&accntStatus-eq=active' + '&isIncludeTest=' + this.includeTest_License;
    this.accountData.filterParam = filterParam;
    this.accountData.flag = true;
    this.accountData.count = license.count;
    this.accountService.storeAccountData(this.accountData);
    this.accountService.setLicenseFilterValue(licenseId);
    this.router.navigate(['../accounts/filter/list'], { relativeTo: this.route });

  }
  getAccountsByLicensePkg_Real(license) {
    const licenseId = license.licPkgId;
    const filterParam = 'license-eq=' + licenseId + '&accntStatus-eq=active'+ '&isIncludeTest=' + this.includeTest_License;
    this.accountData.filterParam = filterParam;
    this.accountData.flag = true;
    this.accountData.count = license.count;
    this.accountService.storeAccountData(this.accountData);
    this.accountService.setLicenseFilterValue(licenseId);
    this.router.navigate(['../accounts/filter/list'], { relativeTo: this.route });

  }
  getHealthList(health) {

    const filterparameter = 'healthStatusType-eq=' + health.name + '&' + this.dateTimeFilterArray.filterparam;
    // this.healthService.getHealthResultByStatus(filterparameter)
    // .subscribe(res=>{
    //   this.healthData.data=res;
    this.healthData.filterParam = filterparameter;
    // this.healthService.getTotalFilterCount(filterparameter).
    // subscribe(res=>{
    //   this.healthData.count=res;
    this.healthData.count = health.value;
    this.healthData.flag = true;
    this.healthService.storeHealthData(this.healthData);
    this.router.navigate(['../health'], { relativeTo: this.route });

    // })


    // })

  }
  onDomainChange(event) {
    this.subDomains = [];
    this.domain = '';
    this.subDomain = '';
    for (let i = 0; i < this.sectors.length; i++) {
      if (this.sectors[i].domain === event.target.value) {
        this.domain = this.sectors[i].domain;
        for (let j = 0; j < this.sectors[i].subDomains.length; j++) {
          this.subDomains.push({
            'displayName': this.sectors[i].subDomains[j].displayName,
            'id': this.sectors[i].subDomains[j].id, 'subDomain': this.sectors[i].subDomains[j].subDomain
          });
        }
      }
    }
  }

  onSubDomainChange(event) {
    this.subDomain = '';
    this.subDomain = event.target.value;


  }
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);

  }
  uploadFile() {
   if(this.isValidData( this.fileToUpload, this.domain, this.subDomain)){
    this.loading$ = true;
    this.fileUploadSubscription = this.fileuploadService.postFile(this.fileToUpload, this.domain, this.subDomain)
      .subscribe(
        res => {
          this.uploadres = res;
          this.loading$ = false;
          if (res && res.length === 0) {
            this.api_success = 'CSV uploaded successfully';
          } else {
            this.displayResultInDialog(res);
            this.api_success = res;
          }
        },
        error => {
          this.api_error = error.error;
        }
      );
      } else {
        this.api_error = 'Please select all required fields';
      }
  }




  uploadZipFile() {
    if (this.isValidData(this.fileToUpload)) {
      this.loading$ = true;
    this.fileUploadZipService = this.fileuploadService.postZipFile(this.fileToUpload, this.cp_importedDate)
      .subscribe(
        res => {
          this.uploadres = res;
          this.loading$ = false;
          if (res && res.length === 0) {
            this.api_success = 'CSV uploaded successfully';
          } else {
            // this.displayResultInDialog(res);
            this.api_success = res;
          }
        },
        error => {
          alert(error.error);
        }
      );
      } else {
        this.api_error = 'Please select all required fields';
      }

  }
  displayResultInDialog(data) {
    const dialogRef = this.dialog.open(DisplayResultDialogComponent, {
      width: '600px',
      data: { 'res': data, 'filename': this.fileToUpload.name }
    });

    dialogRef.afterClosed().subscribe(result => {

     // console.log('The dialog was closed');
     // console.log(result);

    });
  }

  getConsumers(_count, _agentType, category) {
    this.tableFilters = this.commonService.filterParams_without_operators('consumerDate');
    const filterParam = 'userAgentType=' + _agentType + '&category=' + category +'&isIncludeTest=' + this.accountConsumer + '&isFilterByDate=' + this.consumerdateRange+ '&'+ this.tableFilters;;
    this.customerService.setConsumerCategory(category);
    this.customerService.setUserAgentFilterParam(_agentType);
    this.consumerData.filterParam = filterParam;
    this.consumerData.flag = true;
    this.consumerData.count = _count;
    this.customerService.storeConsumerData(this.consumerData);
    this.router.navigate(['../customers/list'], { relativeTo: this.route });


  }
  public ngOnDestroy(): void {
    if (this.fileUploadZipService) {
      this.fileUploadZipService.unsubscribe();
    }
    if (this.fileUploadSubscription) {
      this.fileUploadSubscription.unsubscribe();
    }
    if (this.healthSubscription) {
      this.healthSubscription.unsubscribe();
    }
    if (this.outOfComplianceSubscription) {
      this.outOfComplianceSubscription.unsubscribe();
    }
    if (this.accountLicenseSubscription) {
      this.accountLicenseSubscription.unsubscribe();
    }
  }
  isValidData(file, domain?, subdomain? ) {

    if (file === undefined || file === null || domain === 0 ||  subdomain === 0) {
      return false;
    } else {
      return true;
    }

  }
  report(){

  }
  generate() {
    this.api_error5 = '';
    this.api_success5 = '';
    const post_data = {
      'dateFrom': this.kamdateFrom,
      'dateTo': this.kamdateTo,
      'email': this.email
    }
    if (this.kamdateFrom && this.kamdateTo && this.email) {
      this.customerService.generatrKAMreport(post_data)
        .subscribe(res => {
          this.api_success5 = 'KAM Report Generated successfully';
          setTimeout(() => {
            this.api_success5 = '';
          }, 3000);
          this.kamdateFrom = '';
          this.kamdateTo = '';
          this.email = '';
        },
          (error) => {
            this.api_error5 = error.error;
          }
        );
      setTimeout(() => {
        this.api_error5 = '';
      }, 3000);
    }
  }
}
